export default () => ({
    root: {
        padding: 16,
        height: '100%',
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
    },
});
